@if (isLoadingPreview) {
    <!-- Loading State -->
    <div class="loading-container">
      <app-loading-page 
        [isFullScreen]="false"
        [message]='previewLoadingMessage'
      ></app-loading-page>
    </div>
  }
  @else if (previewData) {
    <!-- Preview Data -->
    <div class="plan-summary">
      @if (previewData.oldPlanName !== previewData.newPlanName) {
        <p><strong>Old plan:</strong> {{ previewData.oldPlanName }}</p>
        <p><strong>New plan:</strong> {{ previewData.newPlanName }}</p>
      } @else {
        <p><strong>Plan:</strong> {{ previewData.oldPlanName }}</p>
      }
    </div>

    <table class="preview-table">
      <thead>
        <tr>
          <th>Description</th>
          <th>Qty</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        @for (line of previewData.lineItems; track line) {
          <tr>
            <td>{{ line.description }}</td>
            <td>{{ line.quantity }}</td>
            <td>{{ line.amount | currency }}</td>
          </tr>
        }
      </tbody>
    </table>

    <div class="preview-total">
      Subtotal: {{ previewData.subtotal | currency }}<br/>
      Tax: {{ previewData.tax | currency }}<br/>
      @if (previewData.appliedBalance && previewData.appliedBalance !== 0) {
        Applied Balance: {{ previewData.appliedBalance | currency }}<br/>
      }
      <strong>
        Total: {{ previewData.total | currency }}
      </strong>
    </div>

    @if (previewData.nextPaymentAttempt) {
      <p class="next-payment">
        <strong>Next payment date:</strong>
        {{ previewData.nextPaymentAttempt | date:'mediumDate' }}
      </p>
    }
  }
  @else {
    <!-- Fallback -->
    <p>No preview available. Please confirm to continue.</p>
  }
